import { Layers } from 'lucide-react';

import {
  IconSize,
  IconSizeClass,
} from '@/react/portainer/environments/utils/index';

export function getGroupIcon(size: IconSize) {
  return <Layers className={IconSizeClass[size]} />;
}
